import styled from "styled-components";

export const ReadMore = styled.span`
  font-size: ${({ size }) => (size ? size : "20px")};
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
`;
